import { ReactComponent as SimSalesIcon } from '../../../../../assets/icons/Navegation/ventas-sim.svg';
import { ReactComponent as SubmenuIcon } from '../../../../../assets/icons/Navegation/submenu-flecha.svg';
import { icons, triangle, headerTitleStyle } from '../Styles/StylesIcons';
import GenericCollapse from './GenericCollapse';
import GenericNavListItem from './GenericNavListItem';
import GenericListItemButton from './MenuItemWithSubmenu';
import Popover from '@mui/material/Popover';
import Divider from '@mui/material/Divider';

const TriangleIcon = (props) => <SubmenuIcon style={triangle} {...props} />;

const SalesReportsSimMenu = ({
  userPermissions,
  openMenuReportsSales,
  handleClickReportsSales,
  activeStyle,
  drawerOpen,
  header,
  handlePopoverOpen,
  handlePopoverClose,
  openPopover,
  anchorEl,
}) => {
  const submenuContent = (
    <>
      {userPermissions?.includes('MANAGEMENT_REPORTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='MANAGEMENT_REPORTS'
          to='/dashboard/manager/sales/reports-incidence'
          title='Incidencias'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('MANAGEMENT_REPORTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='MANAGEMENT_REPORTS'
          to='/dashboard/manager/sales/monthly'
          title='Ventas por mes'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('MANAGEMENT_REPORTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='MANAGEMENT_REPORTS'
          to='/dashboard/manager/sales/weekly'
          title='Ventas por semana'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('MANAGEMENT_REPORTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='MANAGEMENT_REPORTS'
          to='/dashboard/manager/sales/daily'
          title='Ventas por día'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
    </>
  );

  return (
    <>
      {userPermissions?.includes('MANAGEMENT_REPORTS') && (
        <>
          <Divider style={{ margin: '0 0 4px 0' }} />
          {drawerOpen && (
            <>
              {header?.reports.kind === 'header' && (
                <div style={headerTitleStyle}>{header.reports.title}</div>
              )}
            </>
          )}
          <GenericListItemButton
            onClick={drawerOpen ? handleClickReportsSales : handlePopoverOpen}
            className={'layout-menu-submenu'}
            title='Ventas SIM'
            IconComponent={(props) => <SimSalesIcon style={icons} {...props} />}
            openMenu={openMenuReportsSales}
          />
          {drawerOpen && (
            <GenericCollapse
              className={'layout-menu-submenu-options'}
              openMenu={openMenuReportsSales}
              userPermissions={userPermissions}
            >
              {submenuContent}
            </GenericCollapse>
          )}
          {!drawerOpen && (
            <Popover
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              onBlur={handlePopoverClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: { minWidth: 220 },
                onMouseLeave: handlePopoverClose,
              }}
            >
              <div style={{ padding: 8 }}>{submenuContent}</div>
            </Popover>
          )}
        </>
      )}
    </>
  );
};

export default SalesReportsSimMenu;
